<template>
  <header app-header :class="{open:lnbOn}">
    <div class="cover">
      <div class="top">
        <h1 class="logo">
          <a @click="goPage('/' , true)"></a>
        </h1>
        <ul class="n-bts" v-if="env === 'pc'">
          <li v-for="(item,id) in pages" :key="id" :class="{on:activeId===id+1}">
            <a @click="goPage(item.url)">{{item.name}}</a>
          </li>
          <li>
            <a @click="analytics('guide')" target="_blank">공식 카페</a>
          </li>
        </ul>
        <div class="btn" v-else @click="setOpen" :class="{on:lnbOn}">
          <ul>
            <li>
              <div class="f"></div>
              <div class="b"></div>
            </li>
            <li>
              <div class="f"></div>
              <div class="b"></div>
            </li>
            <li>
              <div class="f"></div>
              <div class="b"></div>
            </li>
          </ul>
        </div>
        <ul class="s-bts">
          <li><a @click="goSns('facebook')" target="_blank"></a></li>
          <li><a @click="goSns('discode')" target="_blank"></a></li>
          <li><a @click="goSns('youtube')" target="_blank"></a></li>
        </ul>
      </div>
      <nav class="lnb" v-if="env === 'mob'">
        <ul class="list" :class="{on:lnbOn}">
          <li>
            <a @click="goDownload">다운로드</a>
          </li>
          <li v-for="(item,id) in pages" :key="id" :class="{on:activeId===id+1}">
            <a @click="goPage(`${item.url}${param(id)}`)">{{item.name}}</a>
            <ul class="sub" v-if="item.sub">
              <li v-for="(sub,sid) in item.sub" :key="sid" :class="{on:aSubId === sid+1 && activeId === id+1}">
                <a @click="goPage(`${item.url}?code=${sid+1}&reset=Y`)">{{sub.name}}</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="https://cafe.naver.com/gameviltalion" target="_blank">공식 카페</a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
  name: 'AppHeader',
  data() {
    return {
      app: null,
      lnbOn: false,
      activeId: 0,
      lastY: 0,
      aSubId: 1,
      pages: [
        { name: '세계관', url: 'world', sub: [{ name: '스토리', url: '' }, { name: '연맹', url: '' }] },
        { name: 'WAR', url: 'war', sub: [{ name: '5 vs 5', url: '' }, { name: '10 vs 10', url: '' }, { name: '20 vs 20', url: '' }, { name: '20 vs 1 vs 20', url: '' }] },
        { name: '클래스', url: 'class', sub: [{ name: '카일', url: '' }, { name: '벨트린', url: '' }, { name: '펠', url: '' }, { name: '아이젠', url: '' }] },
        { name: '미디어', url: 'media' },
      ],
    };
  },
  computed: {
    env() {
      return this.$store.state.environment;
    },
  },
  watch: {
    $route() {
      this.setActive();
    },

  },
  methods: {
    param(id) {
      if (id !== 0 && id !== 1 && id !== 4) {
        return `?code=${id === 3 ? '0' : '1'}&reset=Y`;
      }
      return '?reset=Y';
    },

    goDownload() {
      this.goPage('/', true);
      window.gtag('event', 'click', { event_category: 'Mo_GNB_Down' });
    },

    analytics(url) {
      if (!window.gtag) return;
      switch (url) {
        case 'main':
          window.gtag('event', 'click', { event_category: 'GNB_Main' });
          break;
        case 'guide':
          window.gtag('event', 'click', { event_category: 'GNB_Guide' });
          window.open('https://cafe.naver.com/gameviltalion');
          break;
        case 'world':
          window.gtag('event', 'click', { event_category: 'GNB_World' });
          break;
        case 'war':
          window.gtag('event', 'click', { event_category: 'GNB_War' });
          break;
        case 'class':
          window.gtag('event', 'click', { event_category: 'GNB_Class' });
          break;
        case 'media':
          window.gtag('event', 'click', { event_category: 'GNB_Media' });
          break;
        default:
          break;
      }
    },

    goSns(type) {
      switch (type) {
        case 'facebook':
          window.open('https://www.facebook.com/TalionKR');
          window.gtag('event', 'click', { event_category: 'facebook' });
          break;
        case 'youtube':
          window.open('https://www.youtube.com/channel/UCSq3vF8GoVv5DDQEDY1IsHQ');
          window.gtag('event', 'click', { event_category: 'youtube' });
          break;
        case 'discode':
          window.open('https://discord.gg/P288uys');
          window.gtag('event', 'click', { event_category: 'GNB_Discord' });
          break;
        default:
          break;
      }
    },

    goPage(url, close) {
      this.$router.push(url);
      if (this.env === 'mob') {
        let target = $(`#${this.$route.name}`);
        if (target.length === 0) return;

        if (this.$route.name === 'reservation') target = target.find('h1');
        if (this.$route.name === 'class' && this.$route.query && this.$route.query.code > 0)target = target.find('.swiper-container');

        const offset = target.offset().top;
        $('#app').css('height', 'auto');
        $(window).scrollTop(offset);
        setTimeout(() => {
          this.setOpen(close);
        }, 30);
      }
      this.analytics(this.$route.name);
      this.setActive();
    },
    setActive() {
      const p = this.$route;
      this.activeId = _.findIndex(this.pages, o => p.path.indexOf(o.url) > -1) + 1;
      this.aSubId = Number(p.query.code);
    },
    setOpen(close) {
      // console.log(close);
      const bool = this.getType(close) === 'Boolean' || close === undefined;
      this.lnbOn = bool && close ? false : !this.lnbOn;
      if (this.lnbOn) {
        this.lastY = $(window).scrollTop();
        $('#app').height($(window).height());
        $(document.body).css('overflow', 'hidden');
      } else {
        if (!bool) {
          $('#app').css('height', 'auto');
          $(window).scrollTop(this.lastY);
        }
        $(document.body).css('overflow', 'auto');
      }
    },

    setMarkerToggle() {
      let i = 0;
      let s = 0;
      const target = $('.marker');

      function mov() {
        s = s === 0 ? 1 : 0;
        target.animate({
          opacity: s,
        }, 500, () => {
          if (s === 0) {
            if (i === 1) {
              target.removeClass('sec');
            } else {
              target.addClass('sec');
            }
            i = i === 0 ? 1 : 0;
            setTimeout(mov, 300);
          } else {
            setTimeout(mov, 1000);
          }
        });
      }

      mov();
    },

    getType(target) {
      return Object.prototype.toString.call(target).slice(8, -1);
    },
  },

  mounted() {
    if (this.env === 'pc') {
      this.setActive();
    } else if (this.$route.name) {
      setTimeout(() => {
        this.goPage(this.$route.name, true);
      }, 60);
    }
    this.setMarkerToggle();
  },
};
</script>

<style lang="less">
  @import "../less/proj";
  .mob{
    [app-header].open{.wh(100%,100%);
      nav{overflow-y: scroll; }
    }
    [app-header]{ .wh(100%,84); .fix; z-index: 100;
      .top{ .wh(100%,84);  background:rgba(0,0,0,0.7); .abs;
        &:after{.cnt; .wh(100%,2); .contain("@{mob}/headerline.png"); .abs; .b(0); }
        h1{ .wh(139,45); .contain("@{mob}/logo.png"); .mt(20); .ml(80);
          a{.block; .wh(100%);}
        }
        .s-bts{ .abs; .r(23); .t(23);
          li{ .ib; .wh(37); .ml(4); transition: .5s;
            a{.block; .wh(100%); opacity: .5; transition: .5s;}
          /*  &:nth-of-type(1){.wh(131,32); .abs; .contain("@{mob}/btn-shareE.png"); .r(132); .t(2);
              &.sec{.contain("@{mob}/btn-shareE2.png");}
            }*/
            &:nth-of-type(1){.contain("@{mob}/btn-share1.png");}
            &:nth-of-type(2){.contain("@{mob}/btn-share4.png");}
            &:nth-of-type(3){.contain("@{mob}/btn-share3.png");}
          }
        }
        .n-bts{
          li{.fs(20);}
        }
        .btn{.abs; .l(23); .t(25); .pointer; z-index:1;
          p{.fs(24); color:#ffd2a6; .pl(55); .lh(26); opacity: 0; transition: .5s;}
          ul{.abs; .wh(35,30); overflow:hidden; transition:.3s; .t(2);
            li{.abs; .wh(70,5); transition: .3s;
              .f,.b{.abs; .ib; .wh(35,100%); background: white;}
              .b{transform: translate(150%,0); z-index: 10; .t(0);}
              &:nth-of-type(1){.l(0); .t(0);
              }
              &:nth-of-type(2){.l(0); .t(50%); transform: translateY(-50%);
              }
              &:nth-of-type(3){.l(0); .b(0);
              }
            }
          }
          &.on{
            p{opacity: 1;}
            ul{
              li{
                &:nth-of-type(1) {transform: rotate(45deg) translate(50%,0%); .ml(-30);}
                &:nth-of-type(2) { opacity: 0;}
                &:nth-of-type(3) {transform: rotate(-45deg) translate(50%,0%); .ml(-30);}
              }
              /*li{*/
              /*  &:nth-of-type(1) {transform: translate(-50%,240%)!important; transition-delay: 0s;*/
              /*    .b{transform: translate(100%,0);}*/
              /*  }*/
              /*  &:nth-of-type(2) {transform: translate(-50%, -50%);*/
              /*    .b{transform: translate(100%,0);}*/
              /*  }*/
              /*  &:nth-of-type(3) {transform: translate(-50%,-240%)!important; transition-delay: 0s;*/
              /*    .b{transform: translate(100%,0);}*/
              /*  }*/
              /*}*/
            }
          }
        }
      }
      nav{.abs; .t(0); z-index:-1; .wh(100%,100%);
        .list{.w(100%); background: black; .pt(107); .pb(50); transition: .5s; transform: translateX(-100%);
          &.on{transform: translateX(0); .min-h(100%);}
          >li{
            &.on{
              >a{background: #912023; color:white;}
            }
            &:nth-of-type(1){.-t(#912023);}
            >a{.block;.wh(100%,98); .-box;  .pl(78);  .-b(#912023); .fs(34); .lh(98); .bold; color:#ffd2a6;}
            .sub{.p(30,0,30,78); .-b(#912023);
              >li{ .p(13,0);
                &:before{content:'-'; .fs(26); .abs; color:white; }
                a{.block; .fs(26); color:white; .pl(40);}
                &.on{
                  a, &:before{color:#912023;}
                }
              }
            }
          }
        }
      }
    }
  }

  .pc{
    [app-header]{ .wh(100%,86px); background:rgba(0,0,0,0.7); .abs; z-index: 100;overflow-x: hidden;
      .cover{ .min-w(1140px); .rel;
        h1{ .wh(228px,100%); .contain("@{pc}/logo.png"); .ib; .abs;
          a{.block; .wh(100%);}
        }
        .n-bts{.wh(800px,100%); .ib-list; white-space: nowrap; .pt(35px); .-box;.mh-c; .rel;
          li{.w(20%); .bold; .fs(20px,46px); color:white; .tc;.rel;
            a{.block;}
            &:before{.cnt; .contain("@{pc}/thumb-on-effect.png"); .wh(100%,46px); .bg-s(68px,46px); .bg-x(50%); .abs; .t(-58px); .hide;}
            &.on , &:hover{
              a{ color:#912023;}
            }
            &.on{
              &:before{.block;}
            }
          }
        }
        .s-bts{ .abs; .r(42px); .t(45px);
          li{ .ib; .wh(30px); .ml(8px); transition: .5s;
            a{.block; .wh(100%); opacity: .5; transition: .5s;}
         /*   &:nth-of-type(1){.wh(82px,23px); .abs; .contain("@{pc}/btn-shareE.png"); .l(-90px); .t(3px);
              &.sec{.contain("@{pc}/btn-shareE2.png");}
            }*/
            &:nth-of-type(1){.contain("@{pc}/btn-share1.png");}
            &:nth-of-type(2){.contain("@{pc}/btn-share4.png");}
            &:nth-of-type(3){.contain("@{pc}/btn-share3.png");}
            &:hover{
     /*         &:nth-of-type(1){.contain("@{pc}/btn-share1-on.png");}
              &:nth-of-type(2){.contain("@{pc}/btn-share3-on.png");}*/
            }
          }
        }
      }
    }
    @media screen and (max-width: @screen-xxl-min){
      [app-header]{.h(63px);
        .cover{
          h1{ .bg-y(-10px);}
          .n-bts{ .pt(0); .w(700px);
            li{.fs(15px,63px);
              &:before{.t(-16px); .bg-s(50px,34px);}
            }
          }
          .s-bts{.t(22px);
            li{.wh(20px); .ml(5px);}
          }
        }
      }
    }
  }

  /*.marker {*/
  /*  -webkit-animation: fadeOut 2s 1s infinite alternate;*/
  /*  -moz-animation: fadeOut 2s 1s infinite alternate;*/
  /*  -ms-animation: fadeOut 2s 1s infinite alternate;*/
  /*  -o-animation: fadeOut 2s 1s infinite alternate;*/
  /*  animation: fadeOut 2s 1s infinite alternate;*/
  /*}*/
  /*@keyframes fadeOut {*/
  /*  0% {*/
  /*    opacity: 0;*/
  /*  }*/
  /*  100% {*/
  /*    opacity: 1;*/
  /*  }*/
  /*}*/
  /*@-webkit-keyframes fadeOut {*/
  /*  0% {*/
  /*    opacity: 1;*/
  /*  }*/
  /*  100% {*/
  /*    opacity: 0;*/
  /*  }*/
  /*}*/
  /*@-moz-keyframes fadeOut {*/
  /*  0% {*/
  /*    opacity: 1;*/
  /*  }*/
  /*  100% {*/
  /*    opacity: 0;*/
  /*  }*/
  /*}*/
  /*@-ms-keyframes fadeOut {*/
  /*  0% {*/
  /*    opacity: 1;*/
  /*  }*/
  /*  100% {*/
  /*    opacity: 0;*/
  /*  }*/
  /*}*/
  /*@-o-keyframes fadeOut {*/
  /*  0% {*/
  /*    opacity: 1;*/
  /*  }*/
  /*  100% {*/
  /*    opacity: 0;*/
  /*  }*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue